import { useQuery } from '@tanstack/react-query';
import { hoApi } from '../api';

/** Active promotions to issue a coupon of, found as the user types (the server searches; drafts and ended ones are left out). */
export function usePromotions(search: string) {
  return useQuery({
    queryKey: ['ho', 'reward-promotions', search],
    queryFn: async () => {
      const { data, error } = await hoApi.GET('/api/v1/promotions/promotions', { params: { query: { search: search || undefined, page: 1, pageSize: 25 } } });
      if (!data) throw error;
      return data.items.filter((p) => p.status === 'active').map((p) => ({ id: p.id, text: `${p.code} · ${p.name}` }));
    },
  });
}

export function useVoucherBatches(search: string) {
  return useQuery({
    queryKey: ['ho', 'reward-batches', search],
    queryFn: async () => {
      const { data, error } = await hoApi.GET('/api/v1/membership/gift-voucher-batches', { params: { query: { search: search || undefined, page: 1, pageSize: 25 } } });
      if (!data) throw error;
      return data.items.map((b) => ({ id: b.id, text: b.name }));
    },
  });
}

/** Account numbers as typed or pasted: one per line or separated by commas, spaces or semicolons; repeats dropped. */
export function accountNumbers(text: string): string[] {
  return [...new Set(text.split(/[\s,;]+/).map((n) => n.trim().toUpperCase()).filter(Boolean))];
}
